/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHospital = createReactComponent("outline", "hospital", "IconHospital", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M10 16v-8", "key": "svg-1" }], ["path", { "d": "M14 16v-8", "key": "svg-2" }], ["path", { "d": "M10 12h4", "key": "svg-3" }]]);

export { IconHospital as default };
//# sourceMappingURL=IconHospital.mjs.map
